import { render, staticRenderFns } from "./ListRenewalDomain.vue?vue&type=template&id=af92772c"
import script from "./ListRenewalDomain.vue?vue&type=script&lang=js"
export * from "./ListRenewalDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports